import React from 'react';
import ReactDOM from 'react-dom/client'; // Note: 'react-dom/client' instead of 'react-dom'
import './index.css';
import App from './App';
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";

// Create the root and render the app
const root = ReactDOM.createRoot(document.getElementById('root')); 
root.render(
  <React.StrictMode>
    <App />
    <Analytics />
    <SpeedInsights />
  </React.StrictMode>
);
